export default function openScanner(value) {
    window.setShowScanner(!value?.cancel);
}
